import React, { useEffect, useRef, useState } from 'react';
import {ReactComponent as FaceBtn} from '../../assets/images/face-icon.svg';
import {ReactComponent as FaceThumb1} from '../../assets/images/head-thumb-1.svg';
import {ReactComponent as FaceThumb2} from '../../assets/images/head-thumb-2.svg';
import {ReactComponent as FaceThumb3} from '../../assets/images/head-thumb-3.svg';
import {gsap, ScrollTrigger, MotionPathPlugin } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

export default function FaceExpansion({expandOnce, handleChange}) {

  let expandRef = useRef(null);
  const [expanded, setExpanded] = useState(expandOnce);

  let tl = gsap.timeline();
   

  useEffect(() => {
    if(!expanded) {
      tl.to(expandRef.current.childNodes, {
        opacity: 0,
        duration: 0.3,
        stagger: 0.1
      }).yoyo()
      gsap.to(expandRef.current, {
        opacity: 0,
        duration: 1,
      });
    } else {
      gsap.to(expandRef.current, {
        opacity: 1,
        duration: 1,
        // delay: 1
      });
      tl.to(expandRef.current.childNodes, {
        opacity: 1,
        duration: 0.3,
        stagger: 0.1
      }).yoyo()
      
    }
  }, [expanded])

  useEffect(() => {
    setExpanded(expandOnce);
  }, [expandOnce])

  return (
    <div
      style={{height: '268px'}}
      className='cloth-expansion borde border-teal-300 flex w-24 flex-wrap justify-center'>
      <div className='z-10'>
        <button
          onClick={() => setExpanded(!expanded)}
          className='rounded-full w-12 h-12 flex justify-center items-center focus:outline-none' 
          style={{background: '#5C0BD9', zIndex: 4}}
          aria-label='Click on the button for options to swap faces of the human illustration.'  
        >
          <FaceBtn style={{width: '90%', height: '90%'}}/>
        </button>
      </div>
      <div
        ref={expandRef}
        style={{
          top: '-20px', 
          position: 'relative', 
          zIndex: 3, 
          height: '220px', 
          boxShadow:'0px 0px 13.9515px #E2E2FF',
          opacity: 0,
          width: '73%'
        }}
        className='flex flex-wrap w-20 h-24 border-gray-200 rounded-lg justify-center pt-8'>
          <button  
            onClick={() => handleChange(1)}
            className='w-12 interact-icon'
            aria-label="Click to choose oval face with wavy mid length hair and a pair of spectacles in round frame."
          >
            <FaceThumb1 />
          </button>
          <div className='w-full text-center flex justify-center'>
            <button 
              onClick={() => handleChange(2)}
              className='w-9 interact-icon'
              aria-label="Click to chooser oval face with short length ponytail."
            > 
              <FaceThumb2/>
            </button>
          </div>
          <button
            onClick={() => handleChange(3)}
            className='w-9 interact-icon'
            aria-label="Click to choose oval face with mid length straight hair and bangs."
          >
            <FaceThumb3/>
          </button>
      </div>
    </div>
  )
}